<template>
	<div>fsfsdfs</div>
</template>

<script>
	export default{
		created(){
			//this.Config.goHome();
		},
	}
</script>

<style>
</style>
